/**
 * author Christopher Blum
 *    - based on the idea of Remy Sharp, http://remysharp.com/2009/01/26/element-in-view-event-plugin/
 *    - forked from http://github.com/zuk/jquery.inview/
 */
(function (factory) {
    if (typeof define == 'function' && define.amd) {
      // AMD
      define(['jquery'], factory);
    } else if (typeof exports === 'object') {
      // Node, CommonJS
      module.exports = factory(require('jquery'));
    } else {
        // Browser globals
      factory(jQuery);
    }
  }(function ($) {

    var inviewObjects = [], viewportSize, viewportOffset,
        d = document, w = window, documentElement = d.documentElement, timer;

    $.event.special.inview = {
      add: function(data) {
        inviewObjects.push({ data: data, $element: $(this), element: this });
        // Use setInterval in order to also make sure this captures elements within
        // "overflow:scroll" elements or elements that appeared in the dom tree due to
        // dom manipulation and reflow
        // old: $(window).scroll(checkInView);
        //
        // By the way, iOS (iPad, iPhone, ...) seems to not execute, or at least delays
        // intervals while the user scrolls. Therefore the inview event might fire a bit late there
        //
        // Don't waste cycles with an interval until we get at least one element that
        // has bound to the inview event.
        if (!timer && inviewObjects.length) {
           timer = setInterval(checkInView, 250);
        }
      },

      remove: function(data) {
        for (var i=0; i<inviewObjects.length; i++) {
          var inviewObject = inviewObjects[i];
          if (inviewObject.element === this && inviewObject.data.guid === data.guid) {
            inviewObjects.splice(i, 1);
            break;
          }
        }

        // Clear interval when we no longer have any elements listening
        if (!inviewObjects.length) {
           clearInterval(timer);
           timer = null;
        }
      }
    };

    function getViewportSize() {
      var mode, domObject, size = { height: w.innerHeight, width: w.innerWidth };

      // if this is correct then return it. iPad has compat Mode, so will
      // go into check clientHeight/clientWidth (which has the wrong value).
      if (!size.height) {
        mode = d.compatMode;
        if (mode || !$.support.boxModel) { // IE, Gecko
          domObject = mode === 'CSS1Compat' ?
            documentElement : // Standards
            d.body; // Quirks
          size = {
            height: domObject.clientHeight,
            width:  domObject.clientWidth
          };
        }
      }

      return size;
    }

    function getViewportOffset() {
      return {
        top:  w.pageYOffset || documentElement.scrollTop   || d.body.scrollTop,
        left: w.pageXOffset || documentElement.scrollLeft  || d.body.scrollLeft
      };
    }

    function checkInView() {
      if (!inviewObjects.length) {
        return;
      }

      var i = 0, $elements = $.map(inviewObjects, function(inviewObject) {
        var selector  = inviewObject.data.selector,
            $element  = inviewObject.$element;
        return selector ? $element.find(selector) : $element;
      });

      viewportSize   = viewportSize   || getViewportSize();
      viewportOffset = viewportOffset || getViewportOffset();

      for (; i<inviewObjects.length; i++) {
        // Ignore elements that are not in the DOM tree
        if (!$.contains(documentElement, $elements[i][0])) {
          continue;
        }

        var $element      = $($elements[i]),
            elementSize   = { height: $element[0].offsetHeight, width: $element[0].offsetWidth },
            elementOffset = $element.offset(),
            inView        = $element.data('inview');

        // Don't ask me why because I haven't figured out yet:
        // viewportOffset and viewportSize are sometimes suddenly null in Firefox 5.
        // Even though it sounds weird:
        // It seems that the execution of this function is interferred by the onresize/onscroll event
        // where viewportOffset and viewportSize are unset
        if (!viewportOffset || !viewportSize) {
          return;
        }

        if (elementOffset.top + elementSize.height > viewportOffset.top+350 &&
            elementOffset.top < viewportOffset.top-320 + viewportSize.height &&
            elementOffset.left + elementSize.width > viewportOffset.left &&
            elementOffset.left < viewportOffset.left + viewportSize.width) {
          if (!inView) {
            $element.data('inview', true).trigger('inview', [true]);
          }
        } else if (inView) {
          $element.data('inview', false).trigger('inview', [false]);
        }
      }
    }

    $(w).on("scroll resize scrollstop", function() {
      viewportSize = viewportOffset = null;
    });

    // IE < 9 scrolls to focused elements without firing the "scroll" event
    if (!documentElement.addEventListener && documentElement.attachEvent) {
      documentElement.attachEvent("onfocusin", function() {
        viewportOffset = null;
      });
    }
  }));
/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS

*/

// Responsive tables init

$(document).ready(function() {
    $('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');
});

// Wow Animation init
$(document).ready(function() {
    new WOW().init();
});



// Alpha Digital - Change word Cart to Basket
$(document).ready(function() {
    document.getElementsByTagName("title")[0].innerHTML = document.getElementsByTagName("title")[0].innerHTML.replace("Cart", "Basket");

    if(document.getElementsByClassName('step__footer__previous-link-content').length) {
        document.getElementsByClassName('step__footer__previous-link-content')[0].innerHTML = document.getElementsByClassName('step__footer__previous-link-content')[0].innerHTML.replace("cart", "Basket");
        document.getElementsByClassName('breadcrumb__link')[0].innerHTML = document.getElementsByClassName('breadcrumb__link')[0].innerHTML.replace("Cart", "Basket");
    } else {

        jQuery("#cartSlideoutWrapper .cart-item-count-text").text(jQuery("#cartSlideoutWrapper .cart-item-count-text").text().replace("cart", "Basket"));
        jQuery("#cartSlideoutWrapper .cart-item-price-text").text(jQuery("#cartSlideoutWrapper .cart-item-price-text").text().replace("cart", "Basket"));
        jQuery("#cartSlideoutWrapper .slide-checkout-buttons .btn-success").text(jQuery("#cartSlideoutWrapper .slide-checkout-buttons .btn-success").text().replace("Cart", "Basket"));
        if(jQuery("#update_quantities").length>0) { jQuery("#update_quantities").val(jQuery("#update_quantities").val().replace("Cart", "Basket")); }
        jQuery("#your-shopping-cart .title-bar h2").text(jQuery("#your-shopping-cart .title-bar h2").text().replace("Cart", "Basket"));

        jQuery("button:contains('Cart')").each(function() { jQuery(this).text(jQuery(this).text().replace("Cart", "Basket")); });
    }
});
// Mobile Browser Menu

$("select#mobile-menu").change(function() {
    window.location = $(this).find("option:selected").val();
});

// FancyBox

$(document).ready(function() {
    $(".fancybox").fancybox();
});

$(document).ready(function() {
    $(".fancybox-instagram").fancybox({
        padding : 0
    });
});




// Login Boxes

$("#forgot-password-box").click(function(){
    $("#customer-login").hide();
    $("#recover-password").show();
});

$("#login-box-link").click(function(){
    $("#customer-login").show();
    $("#recover-password").hide();
});

// Drawers

var MOBILE_DRAWER_SIZE = 350,
    DESKTOP_DRAWER_SIZE = 450,
    MOBILE_WIDTH_MAX = 768;

window.slideouts = {};


// Simulate responsiveness of the Drawer component
$(window).resize(function () {
    var is_mobile = document.body.clientWidth < MOBILE_WIDTH_MAX;

    // Disable mobile drawer on desktop
    window.slideouts.left._touch = is_mobile;

    if (!window.slideouts.right) {
        // cart slider is disabled
        return;
    }

    // Resize right drawer based on window width
    var slideout = window.slideouts.right,
        padding = (is_mobile) ? MOBILE_DRAWER_SIZE : DESKTOP_DRAWER_SIZE;
    slideout._translateTo = slideout._padding = padding * slideout._orientation;
    if (slideout._opened) {
        var transform = "translateX(" + (padding * slideout._orientation) + "px)";
        slideout.panel.style.webkitTransform = transform;
        slideout.panel.style.transform = transform;
    }
});


function create_drawer(side, panel, menu, hidden_menu, overlay) {
    var padding = MOBILE_DRAWER_SIZE;
    if (side === 'right' && document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        padding = DESKTOP_DRAWER_SIZE;
    }

    var slideout = new Slideout({
        'panel': panel,
        'menu': menu,
        'padding': padding,
        'tolerance': 70,
        'side': side,
        'touch': false
    });
    var dir = (side === 'right') ? -1 : 1;
    window.slideouts[side] = slideout;
    menu.classList.add('slideout-panel-hidden');

    var $overlay = $(overlay);
    overlay.addEventListener('click', slideout.close.bind(slideout));
    $('#slideout-overlay').on('click', function() {
        $('.ajaxcart__discount-title').show();
        $('#af_cart_slider').hide();
    })

    // Handle slide to close
    var touch_start = null;
    overlay.addEventListener('touchstart', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        event.preventDefault();
        touch_start = event.touches[0].pageX;
    });
    overlay.addEventListener('touchmove', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.touches[0].pageX;
        var translate = (dir * padding) - offset;
        if (Math.abs(translate) > padding) {
            translate = (dir * padding);
        }
        panel.style.webkitTransform ='translateX(' + translate + 'px)';
        panel.style.transform ='translateX(' + translate + 'px)';
    });
    overlay.addEventListener('touchend', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.changedTouches[0].pageX;
        if (offset === 0 || Math.abs(offset) > 70) {
            slideout.close(slideout);
        } else {
            panel.style.webkitTransform = 'translateX(' + (dir * padding) + 'px)';
            panel.style.transform = 'translateX(' + (dir * padding) + 'px)';
        }
    });

    slideout.on('beforeopen', function() {
        menu.classList.remove('slideout-panel-hidden');
        if (hidden_menu) {
            hidden_menu.classList.add('slideout-panel-hidden');
        }
        // $overlay.show();
        // document.body.style.overflowY = 'hidden';
        // var marginTop = (-document.body.scrollTop) + 'px';
        // panel.style.position = 'fixed';
        // panel.style.marginTop = marginTop;
    });

    slideout.on('beforeclose', function () {
        // $overlay.hide();
        // var scrollTop = -parseInt(panel.style.marginTop);
        // panel.style.position = '';
        // panel.style.marginTop = '';
        // document.body.scrollTop = scrollTop;
    });

    slideout.on('close', function() {
        menu.classList.add('slideout-panel-hidden');
    });
    slideout.on('translate', function(translated) {
        var hidden = false;
        if (translated === 0) {
            hidden = true;
        } else if (side === 'left') {
            hidden = translated <= 0;
        } else if (side === 'right') {
            hidden = translated >= 0;
        }
        menu.classList.toggle('slideout-panel-hidden', hidden);
        if (hidden_menu) {
            hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
        }
    });

    return slideout;
}

function load_menu_drawer() {

    // Close sliders if they're open
    if (window.slideouts && window.slideouts.left) {
        window.slideouts.left.close();
    }
    if (window.slideouts && window.slideouts.right) {
        window.slideouts.right.close();
    }

    /* Move mobile menu out of section to document body because the slideout
       needs to put it to the sidebar, but it can't be in the body from the beginning
       because it needs section config */
    var body_menu = $('body > #menu');
    var main_body_menu = $('#main-body #menu');
    if (main_body_menu.length > 0) {
        body_menu.remove();
        $('body').append(main_body_menu);
    }

    var main_body = document.querySelector('#main-body');
    var left_menu = document.querySelector('#menu');
    var right_menu = document.querySelector('#cartSlideoutWrapper');
    var overlay = document.querySelector('#slideout-overlay');

    /* Mobile Menu */

    var slideoutLeft = create_drawer('left', main_body, left_menu, right_menu, overlay);

    $('.slide-menu-mobile').on('click', function() {
        slideoutLeft.toggle();
    });

    $('.mobile-menu-close').on('click', function () {
        slideoutLeft.close();
    });

    // Disable mobile drawer on desktop
    if (document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        slideoutLeft._touch = false;
    }

    // Add events for sidebar manipulation from outside
    $(left_menu)
        .on('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft))
        .on('mobile:open', slideoutLeft.open.bind(slideoutLeft))
        .on('mobile:close', slideoutLeft.close.bind(slideoutLeft));

    /* Cart */
    if (!right_menu) {
        // Cart drawer is disabled in the settings
        return;
    }
    var slideoutRight = create_drawer('right', main_body, right_menu, left_menu, overlay);

    // Toggle button
    $('.slide-menu-cart').on('click', function (e) {
        slideoutRight.toggle();
        flyOutCartSlider();
        // prevent non-ajax basket
        e.preventDefault();
        return false;
    });

    $('.cart-menu-close').on('click', function (e) {
        slideoutRight.close();
        $('.ajaxcart__discount-title').show();
        $('#af_cart_slider').hide();

    });

    // Add events for sidebar manipulation from outside
    $(right_menu)
        .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
        .on('cart:open', slideoutRight.open.bind(slideoutRight))
        .on('cart:close', slideoutRight.close.bind(slideoutRight));
}

$(document).ready(load_menu_drawer);
document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'header') {
        load_menu_drawer();
    } else if (event.detail.sectionId === 'footer') {
        // Shopify doesn't correctly handle scrolling to footer on section change because the section
        // has zero height when it's scrolled to but when it loads it gets out of visible area
        setTimeout(function () {
            // Scroll to the footer element after loading
            document.documentElement.scrollTop = document.body.scrollTop = document.body.clientHeight;
        }, 0);
    }
});

// Google Maps JS

// Set map Variables
var MAP_SELECTOR = '.map-wrapper';
var MAP_API_FAILED = false;
var map_objects = [];

function set_map_error(message, container) {
    if (!container) {
        container = $('.map-section__container');
    }
    container.addClass('hide');
    if (Shopify.designMode) {
        $('<div class="map-container-error"></div>').text(message).appendTo(container.parent().find('.map-section__overlay'));
    }0
    container.parent().find('.homepage-map--fallback').removeClass('hide');
}

function maps_resize() {
    // Center map when screensize is changed
    map_objects.forEach(function (map) {
        var currCenter = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(currCenter);
    });
}

function map_init(map_element) {
    var config = {
        zoom: 14
    };

    var section = map_element.dataset.id;
    var colors = map_element.dataset.colors;
    var style = [];
    try {
        style = JSON.parse(document.getElementById('homepage-map--theme--' + section).textContent);
    } catch (e) {
        console.error('Unable to parse theme style:', e);
    }
    var container = document.querySelector('#map-container-' + section);
    if (!container) {
        return;
    }
    var $container = $(container);
    if (MAP_API_FAILED) {
        set_map_error('Google Maps authentication error, API key might be invalid', $container);
    }

    var map = new google.maps.Map(container, {
        zoom: config.zoom,
        styles: style,
        disableDefaultUI: true,
        draggable: false,
        clickableIcons: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
    });
    map_objects.push(map);

    var geocoder = new google.maps.Geocoder();

    geocodeAddress(geocoder, map);

    function geocodeAddress(geocoder, resultsMap) {
        var address = $('#map-container-' + section).data('address-setting');
        geocoder.geocode({'address': address}, function(results, status) {
            if (status === 'OK') {
                resultsMap.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: resultsMap,
                    position: results[0].geometry.location
                });
            } else {
                set_map_error('Error looking up that address', $container);
            }
        });
    }
}

// Google Map JS
function load_googlemaps() {
    var apiKey = null;
    Array.prototype.forEach.call(document.querySelectorAll(MAP_SELECTOR), function (map_element) {
        var section = map_element.dataset.id;
        var elementApiKey = document.querySelector('#apikey-' + section).value;
        if (!elementApiKey) {
            return;
        }
        if (apiKey && elementApiKey && elementApiKey !== apiKey) {
            console.warn('Multiple different Google Maps API keys are not allowed, using only the first one');
            return;
        }
        apiKey = elementApiKey;
    });
    if (!apiKey) {
        console.error('Google Maps API key not provided!');
        set_map_error('Google Maps API key not provided!', null);
        return;
    }

    if (MAP_API_FAILED || !window.google || !window.google.maps || !window.google.maps.Geocoder || !window.google.maps.Map) {
        MAP_API_FAILED = false;
        $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=google_maps_loaded'
        );
    } else {
        google_maps_loaded();
    }
}

function google_maps_loaded() {
    Array.prototype.forEach.call(document.querySelectorAll(MAP_SELECTOR), map_init);
    $(window).off('resize', maps_resize).on('resize', maps_resize);
}

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars

function gm_authFailure() {
    MAP_API_FAILED = true;
    console.error('Authentication Failure');

    var $container = $('.map-section__container');

    set_map_error('Google Maps authentication error, API key might be invalid', null);
}

$(document).ready(load_googlemaps);
document.addEventListener('shopify:section:load', function (event) {
    load_googlemaps();
});

// Product shipping
$(document).ready(function() {
    if($(window).width() < 768) {
        $('.product__shipping--mobile .product__shipping-title').click(function() {
            $('.product__shipping--mobile .product__shipping-content').slideToggle();
        })
    }
});

$(document).ready(function() {
    if ($(window).width() < 768 && $('.template-product').length) {
        let btn = $('#purchase');
        let btnPos = btn.offset().top;
        $(window).on('scroll', function () {
          if ($(window).scrollTop() > btnPos + ($(window).height() / 2 - 400)) {
            $('.product__sticky').addClass('visible');
          } else {
            $('.product__sticky').removeClass('visible');
          }
        })
      }
    $('.product__sticky-btn').click(function() {
        $('#purchase').click();
    })
});

// Product shipping
$(document).ready(function() {
    const target = document.querySelector('.ajaxcart__bottom');
    const config = {
        subtree: true,
        childList: true,
    };

    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                if($('#af_cart_slider').length) {
                    observer.disconnect();
                    $('.ajaxcart__discount-title').show();
                    $('.ajaxcart__discount-btn').click(function() {
                        $('.ajaxcart__discount-title').hide();
                        $('#af_cart_slider').show();
                    })
                }
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(target, config);
    $('.ajaxcart__discount-btn').click(function() {
        $('.ajaxcart__discount-title').hide();
        $('#af_cart_slider').show();
    })
});

// Collection slider

$(document).ready(function() {

    $('.homepage-featured-products-slick').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite:false,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true
          }
        }
      ]
    })

// Related Products PDP slider

    $('.product-related').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true
          }
        }
      ]
    })

    // Blog Article slider

    $('.grid--blog').slick({
      slidesToShow: 3,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1

          }
        }
      ]
    })



    // $('.homepage-featured-products-collections-slick').slick({
    //   slidesToShow: 4,
    //   dots: false,
    //   arrows: true,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 2
    //       }
    //     }
    //   ]
    // })

    $('.c-slider__list').slick({
        slidesToShow: 7,
        prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev"><i class="fa fa-chevron-left"></i></div>',
        nextArrow: '<div class="c-slider__arrow c-slider__arrow--next"><i class="fa fa-chevron-right"></i></div>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    arrows: false
                }
            }
        ]
    })

    $('.testimonial-slider-slick').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    })


    $('.confidence__inner').slick({
        dots: false,
        infinite: true,
        arrows: false,
        speed: 300,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
            },
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
            }
        ]
    });
    //Category slider
    $('.category-slider__list').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite:false,
        dots: false,
        arrows: true,
        swipeToSlide: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          }
        ]
      })


})





$(document).ready(function () {
    //TABS

        $(".product__tab-content").slideUp()
        $('.product__tab-title').on('click', function() {
            if( $(this).hasClass('open')) {
                $(this).removeClass('open')
                $(this).next().slideUp()
            } else {
                    // $(".product__tab-content").slideUp()
                    $(this).next().slideDown()
                    // $('.product__tab-title').removeClass('open')
                    $(this).addClass('open')
            }

        })
})






$(document).ready(function() {

    const $quickBuyBtn = $('.tt-quick-buy');
    const $collectionItem = $('.indiv-product');
        if($(window).width() > 992) {
            $collectionItem.on('mouseover', function(e) {
                e.preventDefault();
                $(this).find($quickBuyBtn).removeClass('hide-btn')
            })
            $collectionItem.on('mouseleave', function(e) {
                e.preventDefault();
                $(this).find($quickBuyBtn).addClass('hide-btn')
            })

        } else {
            $('#shopify-section-collection-template .grid__item').on('inview', function (event, visible, topOrBottomOrBoth) {
                if (visible == true) {
                     $(this).find($quickBuyBtn).removeClass('hide-btn')
                 } else {
                    $(this).find($quickBuyBtn).addClass('hide-btn')
                 }
               });
        }


    function load_quantity_controls(){

        $('.tt-modal-quickview .quantity-controls button.qty-plus').off().click(function(e){
            e.preventDefault();
            var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
            qtyInput.val(parseInt(qtyInput.val()) + 1);
        });

        $('.tt-modal-quickview .quantity-controls button.qty-minus').off().click(function(e){
            e.preventDefault();
            var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
            var newQty = (parseInt(qtyInput.val()) - 1 < 1) ? 1 : qtyInput.val() - 1;
            qtyInput.val(newQty);
        });

    }

    function changeImages() {
        $featured_image_wrapper = $('.featured-image-div');
        $featured_image = $('.featured-image-div img');
        $mobile_slider = $('.mobile-product-slider');
        $thumbnail_wrapper = $('#product-thumbnails');
        $thumbnail = $('.tt-thumbnail');

        $thumbnail.on('click', function(e) {
            e.preventDefault();
            var newImage = $(this).find('img');
            var clone = newImage.clone().removeClass('lazyloaded').addClass('lazyload product-main-image')
            $featured_image.replaceWith(clone);
            $featured_image = clone;
            $featured_image_wrapper.find('.zoomImg').remove();
            if ($featured_image_wrapper.data('zoom')) {
                apply_zoom($featured_image_wrapper);
            }
        })

    }











    function initAjaxCart() {
          // Private general variables
  var settings,  $body, config;

  // Private plugin variables
  var $formContainer, $addToCart, $ajaxcartList, $cartItemCount, $cartMoney, $afterPayPrice, $cartSlideoutWrapper, addedTextTimeout, addedTextTimeout, addedTextTimeout;
        settings = {
            formSelector        : '#add-to-cart-form',
            addToCartSelector   : '#purchase',
            ajaxcartList        : '#ajaxcart-list',
            cartItemCount       : '.cart-item-count-header',
            cartMoney           : '.ajaxcart__subtotal',
            afterPayPrice       : '.ajaxcart__after-pay-price',
            cartSlideoutWrapper : '#cartSlideoutWrapper'
        };

        // Select DOM elements
        $formContainer       = $(settings.formSelector),
        $addToCart           = $formContainer.find(settings.addToCartSelector),
        $ajaxcartList        = $(settings.ajaxcartList),
        $cartItemCount       = $(settings.cartItemCount),
        $cartMoney           = $(settings.cartMoney),
        $afterPayPrice       = $(settings.afterPayPrice),
        $cartSlideoutWrapper = $(settings.cartSlideoutWrapper),
        addedTextTimeout     = null,
        config = {
            shopify_ajax_add_url: '/cart/add.js',
            shopify_ajax_url: '/cart.js',
            shopify_ajax_change_url: '/cart/change.js',
        };

        // General Selectors
        $body = $('body');

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
        console.log('123');
        create_cart();


    function changeItem(line, quantity) {
        var params = {
          type: 'POST',
          url: config.shopify_ajax_change_url,
          data: 'quantity=' + quantity + '&line=' + line,
          dataType: 'json',
          success: cart => {
            updated_cart(cart);
          },
          error: XMLHttpRequest => {
            update_cart_failed(XMLHttpRequest);
          }
        };

        jQuery.ajax(params);
    };

    function addItem(variant_id, quantity, callback) {
      console.log(variant_id, callback);
        // console.log('variant',variant_id)
        quantity = quantity || 1
        var params = {
          type: 'POST',
          url: '/cart/add.js',
          data: 'quantity=' + quantity + '&id=' + variant_id,
          dataType: 'json',
          success: line_item => {
            if ((typeof callback) === 'function') {
              callback(line_item)
            }

            update_cart();
          },
          error: XMLHttpRequest => {
            update_cart_failed(XMLHttpRequest);
          }
        }
        jQuery.ajax(params)
    }

    function add_to_cart()  {
        clear_error();

        $.ajax({
            url: config.shopify_ajax_add_url,
            dataType: 'json',
            type: 'post',
            data: $formContainer.serialize(),
            success: added_to_cart,
            error: add_to_cart_failed
        })
    }

    function added_to_cart(itemData) {
        smHandleCart()
        .then(update_cart);
    };

    function add_to_cart_failed(response) {
        enable_cart_button();
        var errorText = 'Unknown error';
        if (response.status == 0) {
            // Unable to connect to server
        } else if (response.responseJSON) {
            // Process JSON error
            if (response.responseJSON.description) {
                errorText = response.responseJSON.description;
            } else {
                errorText = response.responseJSON.message;
            }
        } else if (response.responseText) {
            // Use plain text error
            errorText = response.responseText;
        }
        show_error(errorText);
    };

    function disable_cart_button() {
        if (addedTextTimeout) {
            clearTimeout(addedTextTimeout);
            addedTextTimeout = null;
        }
        $addToCart.addClass('disabled').prop('disabled', true).html(CART_LOADING);
    };

    function show_error(text) {
        $('<div id="cart-error"></div>')
            .addClass('alert alert-danger')
            .text(text)
            .insertAfter($addToCart);
    };

    function clear_error() {
        $('#cart-error').remove();
    };

    function update_cart_failed(response) {
        enable_cart_button();
        console.error("Updating the cart failed: ", response);
    };

    function enable_cart_button() {
        if (addedTextTimeout) {
            clearTimeout(addedTextTimeout);
            addedTextTimeout = null;
        }
        $addToCart.removeClass('disabled').prop('disabled', false).html(window.theme.strings.addToCart);
    };

    function update_cart() {
        // Update cart count
        $.getJSON(config.shopify_ajax_url)
            .then(updated_cart)
            .fail(update_cart_failed);
    };

    function updated_cart(data) {
        created_cart(data);
        enable_cart_button();

        if ($cartSlideoutWrapper.length) {
            show_cart();
            $.fancybox.close();
        } else {
            $addToCart.html(window.theme.strings.added);
            if (addedTextTimeout) {
                clearTimeout(addedTextTimeout);
                addedTextTimeout = null;
            }
            addedTextTimeout = setTimeout(function () {
                $addToCart.html(window.theme.strings.addToCart);
            }, 2000);
        }
    };

    function create_cart() {
        $.getJSON(config.shopify_ajax_url)
            .then(created_cart)
            .fail(update_cart_failed);
    };

    function created_cart(data) {

        var itemList = ''

        if (data.item_count) {
            data.items.forEach(function(item, index) {

                var itemTemplate = `<div class="ajaxcart__item">
                    <div class="ajaxcart__item-img">
                        <a href="${item.url}" class="ajaxcart__product-img"><img src="${item.image}" alt=""></a>
                    </div>

                    <div class="ajaxcart__item-desc">
                        <a href="${item.url}" class="ajaxcart__product-name">${item.title}</a>
                        <div class = "ajaxcart_product-price">${ formatMoney(item.price) }</div>

                        <div class="ajaxcart__change-qty">
                            <div class="ajaxcart__qty">
                                <button type="button" class="ajaxcart__qty-adjust ajaxcart__qty-minus" data-line="${index + 1}">-</button>
                                <input type="text" name="updates[]" class="ajaxcart__qty-num" value="${item.quantity}" data-line="${index + 1}" aria-label="quantity" pattern="[0-9]*">
                                <button type="button" class="ajaxcart__qty-adjust ajaxcart__qty-plus" data-line="${index + 1}">+</button>
                            </div>

                            <button type="reset" class="ajaxcart__btn-remove" data-line="${index + 1}">${theme.strings.remove}</button>
                        </div>
                    </div>
                </div>`

                itemList += itemTemplate;
            })
        }

        var freeShip = `{{ settings.free_price | times: 100 }}`;
        var shippingPrice = `{{ settings.shipping_price | times: 100 }}`;
        var totalPrice = data.total_price;
        if(data.total_price >= freeShip) {
            $('.ajaxcart__ship-dif, .ajaxcart__shipping-price').hide();
            $('.ajaxcart__ship-free, .ajaxcart__shipping-free').show();
            $('.ajaxcart__shipping-fee').css('display', 'flex');
        }
        else if(data.total_price < freeShip && data.total_price > 0) {
            var dif = freeShip - data.total_price;
            if($('body').hasClass('shipping_fee')) {
                totalPrice = data.total_price + shippingPrice
            }
            $('.ajaxcart__ship-free, .ajaxcart__shipping-free').hide();
            $('.ajaxcart__ship-dif span').html(formatMoney(dif))
            $('.ajaxcart__ship-dif, .ajaxcart__shipping-price').show();
            $('.ajaxcart__shipping-fee').css('display', 'flex');
        }
        else {
            $('.ajaxcart__shipping-fee').hide();
        }

        $ajaxcartList.html(itemList);
        $cartItemCount.text(data.item_count);
        if (data.item_count > 0) {
          $(".cart-item-count-header").addClass('show');
          $(".cart-item-count-header").removeClass('hide');
        } else {
          $(".cart-item-count-header").addClass('hide');
          $(".cart-item-count-header").removeClass('show');
        }
        $cartMoney.html(formatMoney(totalPrice));
        $afterPayPrice.html(formatMoney(data.total_price / 4));
        if (Currency.shopCurrency) {
            Currency.convertAll(Currency.shopCurrency, jQuery('[name=currencies]').val());
        }
    }

    function show_cart() {
        $cartSlideoutWrapper.trigger('cart:open');
        flyOutCartSlider();
    };

    function adjustCart () {
        $body.off('click')

        $addToCart.click(function(e) {
            // console.log('cart')
            e.preventDefault();
            disable_cart_button();
            add_to_cart(e);
        });

        // Add or remove from the quantity
         $body.on('click', '.ajaxcart__qty-adjust', function(e) {
            var $el = $(e.currentTarget),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty-plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                changeItem(line, qty)
            } else {
                $qtySelector.val(qty);
            }
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function(e) {
            var $el = $(e.currentTarget),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                changeItem(line, qty);
            }
        });

        validateQty = function (qty) {
            if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
            } else {
            // Not a number. Default to 1.
            qty = 1;
            }
        return qty;
        };

        // Remove item
        $body.on('click', '.ajaxcart__btn-remove', function(e) {
            var line = $(e.currentTarget).data('line');
            changeItem(line, 0);
        });

        //Add item from fly-out-cart
        $body.on('click', '.fly-out-cart__item-add', function(e) {
            addItem($(e.currentTarget).data('variant-id'), 1, () => {
                $(e.currentTarget).closest('.fly-out-cart__item').remove();

                if($('.fly-out-cart__item').length == 0) {
                    $('.fly-out-cart').remove();
                }
            })
        });
    }

};





// select
var product_script = $('#ProductJson-product-template');
// let $product = (JSON.parse(document.querySelector('#ProductJson-product-template').innerText));
let $selects = $('.selector-wrapper select, .materialize-select select');
const $old_price = $('.compare-at-price .money');
const $price = $('#price-field');
const $cart = $('#purchase');
const $sale = $('.sale-badge,.compare-at-price');
const $sale_price = $('.compare-at-price');

// if (!product_script) {
//         // Product is not loaded, there is either no product section or the product is not selected
//         return;
//     }

 function on_select_change() {
   let $selects = $('.selector-wrapper select, .materialize-select select');
   let $product = JSON.parse(document.querySelector('#ProductJson-product-template').innerText);
    var values = $selects.map(function (index, select) {
        return $(select).val();
    });

    var matching_variants = $product.variants.filter(function (variant) {
        for (var i = 0; i < values.length; i++) {

            if (values[i] !== variant.options[i]) {
                return false
            }
        }
        return true;
    });
    if (matching_variants.length === 0) {

        update_variant(null);
    } else {
        // $('[name="id"]')
        update_variant(matching_variants[0]);
        var variant = matching_variants[0];
        // update_variant(matching_variants[0]);
        for (var i = 0; i < variant.options.length; i++) {
            $('#SingleOptionSelector-' + i).val(variant.options[i]).material_select();
        }
    }
};


 function on_variant_selected (variant_id) {
    let $product = JSON.parse(document.querySelector('#ProductJson-product-template').innerText);

    var matching_variants = $product.variants.filter(function (variant) {
        return variant.id == variant_id;
    });
    if (matching_variants.length === 0) {
        update_variant(null);
    } else {
        var variant = matching_variants[0];
        update_variant(matching_variants[0]);
        for (var i = 0; i < variant.options.length; i++) {
            $('#SingleOptionSelector-' + i).val(variant.options[i]).material_select();
        }
    }
};

$(document).ready(function() {
    if ($(window).width() < 768) {
        $(window).on('scroll', function () {

          if ($(window).scrollTop() > 250) {
            $('body').addClass('scrolled');
            $('.search-results').hide();
          } else {
            $('body').removeClass('scrolled')
          }
        })
      }

      $(".navigation-item__child-items").hover(function() {
        $(this).attr('id');
        var parentElement= "parent-" + $(this).attr('id');
        $("#" + parentElement).addClass("font-bold")
        console.log("1" + parentElement)
        }, function(){
        $(".navigation-item").removeClass("font-bold")
        console.log("2" + "test")
      });


      $(".product__shipping-title").on( "click", function() {
        $(this).closest('.product__shipping').toggleClass("active");
      });

      $(".product-description-wrapper-button").on( "click", function() {
        $(this).closest('.product-description-wrapper-outer').addClass("active");
      });

      $(".product-description-wrapper-button-close").on( "click", function() {
        $(this).closest('.product-description-wrapper-outer').removeClass("active");
      });
})

function update_variant(variant) {
    const $original_select = $('.original-select');
    let $product = JSON.parse(document.querySelector('#ProductJson-product-template').innerText);
    if (variant) {

        $original_select.val(variant.id);
        if (!variant.available) {
            $price.text(theme.strings.soldOut);
            $cart.prop('disabled', true);
            $.event.trigger({
                type: "variantUnavailable",
                time: new Date(),
                variant: variant
            });
        } else {
            $price.html(formatMoney(variant.price));
            $cart.prop('disabled', false);
            $.event.trigger({
                type: "variantAvailable",
                time: new Date()
            });
        }
        if (variant.featured_image) {
            var $thumbnail = this.$thumbnail_wrapper.find('[data-variant="' + variant.id + '"] img');
            if ($thumbnail.length > 0) {
                set_featured_image($thumbnail);
            }

            // var slider = this.$element.find('.mobile-product-slider');
            // if (slider.length === 0) {
            //     slider = this.$element.find('.homepage-sections--indiv-product-slider');
            // }
            // var li_to_activate = slider.find('li:not(.clone) [data-variant="' + variant.id + '"]').parent();
            // var index = slider.data('flexslider').slides.index(li_to_activate);
            // if (index > -1) {
            //     slider.flexslider(index);
            // }
        }
        var is_sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        // this.$sale_price.html(is_sale ? formatMoney(variant.compare_at_price) : '');
        // this.$sale.toggleClass('hide', !is_sale);

        var is_indiv_product = $('.shopify-section').hasClass('homepage-section--indiv-product-wrapper');
        var has_more_variants = $product.variants.length > 1;
        if (window.history.replaceState && !is_indiv_product && has_more_variants) {
            // Change url to include variant if we're not on homepage
            var search = [];
            if (window.location.search.length > 1) {
                // select non-variant query params
                search = window.location.search.slice(1).split('&').filter(function (q) {
                    return q.indexOf('variant=') !== 0;
                });
            }
            // add current variant
            search.push('variant=' + variant.id);

            // set the url to include the variant
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + search.join('&');
            window.history.replaceState({path: newurl}, '', newurl);
        }
    } else {
        $price.text(theme.strings.unavailable);
        $cart.prop('disabled', true);
        // this.$sale.addClass('hide');
    }
    if (Currency.shopCurrency) {
        Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);
    }
};

function set_featured_image ($newImage) {
    var clone = $newImage.clone().removeClass('lazyloaded').addClass('lazyload product-main-image')
    this.$featured_image.replaceWith(clone);
    this.$featured_image = clone;
    this.$featured_image_wrapper.find('.zoomImg').remove();
    if (this.$featured_image_wrapper.data('zoom')) {
        apply_zoom(this.$featured_image_wrapper);
    }
};



    $(".tt-quick-buy").fancybox({
                type: 'ajax',
                src: $(this).data('src'),
                afterShow : function(  ) {
                    $('#fancybox-inner').width(400);
                    $('#fancybox-wrap').width(420);
                    if($('.tt-subcription').length) {
                        startRecharge()
                    }
                    $('select.materialize').material_select();
                    var api = new Yotpo.API(yotpo);
                    api.refreshWidgets();
                    load_quantity_controls();
                    changeImages();
                    $('*[data-zoom=true]').each(function () {
                        apply_zoom(this);
                    });
                    $('.selector-wrapper select, .materialize-select select').on('change', function() {
                        // on_variant_selected()
                        on_select_change()
                    });
                    initAjaxCart()

                }
            })


            const target = document.getElementsByTagName('body')[0];
            const config = {
                subtree: true,
                childList: true,
            };

            const callback = function(mutationsList, observer) {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        if(window.innerWidth < 768) {
                            $('#filter-tabs').slick({
                                slidesToShow: 3,
                                prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev"><i class="fa fa-chevron-left"></i></div>',
                                nextArrow: '<div class="c-slider__arrow c-slider__arrow--next"><i class="fa fa-chevron-right"></i></div>'
                            })
                        }
                        observer.disconnect();
                    }
                }
            };

    const observer = new MutationObserver(callback);
    observer.observe(target, config);

            $('.logo-bar').slick({
                slidesToShow: 5,
                autoplay: true,
                autoplaySpeed: 1000,
                centerMode: false,
                dots: false,
                arrows:true,
                responsive: [
                    {
                      breakpoint: 920,
                      settings: {
                        slidesToShow: 3,
                        dots: false
                      },
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 2,
                        dots: false,
                        arrows:false
                      }
                    }
                  ]
            })



})



$(document).on('click', '.product-subscribe-link', function() {
    if($(this).hasClass('active')) {
        $('.product-subscribe-popup').css('display', 'none');
        $(this).removeClass('active');
    }else {
        $(this).addClass('active');
        $('.product-subscribe-popup').css('display', 'block');
    }
});


$(document).ready(function() {
    productWrapin();
    // test 126
    sleepRoutineProduct();
    chooseThreeDrops();

    // test 138
    // sleepQuizPage();
    // $(window).resize(function(){
    //     if(window.innerWidth < 751) {
    //         if (!$('.collection__list').hasClass('slick-slider')) {
    //             sleepQuizPage();
    //         } 
    //     } else {
    //         if ($('.collection__list').hasClass('slick-slider')) {
    //             $('.collection__list').slick('unslick');
    //         }
    //     }
    // });

    dropMoneyBack();
    test_163();
    test_174();
    productFaq();
    flyOutCartNote();
});

function productWrapin() {
    $('.product-wrapin').on('click', function() {
        $('.product-wapin-bg, .product-wapin-popup').show();
    });
    $('.product-wapin-bg, .js-close-product-wapin-popup').on('click', function() {
        $('.product-wapin-bg, .product-wapin-popup').hide();
    });
}

function sleepRoutineProduct() {
    $('.sleep-routine-product').slick({
        slidesToShow: 3,
        dots: false,
        arrows: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 651,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
}

function sleepQuizPage() {
    if(window.innerWidth < 751) {
        $('.collection__list').slick({
            slidesToShow: 1,
            dots: true,
            arrows: false,
            infinite: true
        });
    }
}

function dropMoneyBack() {
    $('.money-back-drop a[href="#popup"]').on('click', function(){
        $('.money-back-drop-bg, .money-back-drop-popup').show();
        $('body, html').addClass('overflow-hidden');
    });
    $('.close-money-back-drop-popup, .money-back-drop-bg').on('click', function(){
        $('.money-back-drop-bg, .money-back-drop-popup').hide();
        $('body, html').removeClass('overflow-hidden');
    });
}

jQuery(document).on('shopify:section:load', function(e){ 
    chooseThreeDrops();
});

function chooseThreeDrops() {
    var $wrapperSlick = $('.choose-three-drops');

    $('.choose-three-drops .three-drops-item').each(function() {
        var thisItem = $(this);
        var btnAdd = $(this).find('[data-qty]');
        var qtyVal = $(this).find('.qty-val');
        var qtyDown = $(this).find('.qty-down');
        var qtyUp = $(this).find('.qty-up');
        var qty = Number($(qtyVal).val());

        $(qtyDown).on('click', function() {
            qty = Number($(qtyVal).val());

            if (qty - 1 > 0) {
                qty--;
            }

            $(qtyVal).val(qty);
            $(btnAdd).data('qty', qty);
        })

        $(qtyUp).on('click', function() {
            qty = Number($(qtyVal).val());
            
            qty++;

            $(qtyVal).val(qty);
            $(btnAdd).data('qty', qty);
        })
    });

    $('.choose-three-drops-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 651,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.choose-three-drops-slider').on('setPosition', function(event, slick){
        if ($wrapperSlick.hasClass('before-load')) {
            setTimeout(function(){ 
                $wrapperSlick.removeClass('before-load');
            }, 300);
        }
    });
}

function test_163() {
    $('.accordions-heading').on('click', function() {
        $(this).toggleClass('opening');
        $(this).next().slideToggle();
    })
}

function test_174() {
    if($('.dispatch-timer').length > 0) {
        var now = new Date();
        var hoursAustralia = $('.dispatch-timer').data('hours');
        if (hoursAustralia >= 12 && hoursAustralia < 24) {
            $('.dispatch-timer').html('<p>Order now for Next Day Dispatch<p>');
            $('.dispatch-timer').removeClass('hide');
        } else {
            $('.dispatch-timer').removeClass('hide');
            // setInterval(function time(){
            //   var aestTime = new Date().toLocaleString("en-US", {timeZone: "Australia/Brisbane"});
            //   var d = new Date(aestTime);
            //   var hours = 11 - d.getHours();
            //   var min = 59 - d.getMinutes();
            //   if((hours + '').length == 1){
            //     hours = '0' + hours;
            //   }
            //   if((min + '').length == 1){
            //     min = '0' + min;
            //   }
            //   var sec = 60 - d.getSeconds();
            //   if((sec + '').length == 1){
            //         sec = '0' + sec;
            //   }
            //   $('.dispatch-countdown-js .hours').html(hours);
            //   $('.dispatch-countdown-js .min').html(min);
            //   $('.dispatch-countdown-js .sec').html(sec);
            // }, 1000);
        }
    }
}

function productFaq() {
    $('.faq-show-more').on('click', function () {
        if($(this).hasClass('less')) {
            $(this).removeClass('less').text('READ MORE');
            $('.faq-block').removeClass('faq-show');
        } else {
            $(this).addClass('less').text('READ LESS');
            $('.faq-block').addClass('faq-show');
        }
    });
    $('.faq-ques').on('click', function () {
        $(this).parent().toggleClass('active');
        $(this).next().slideToggle();
    });
}


function flyOutCartNote() {
    $('.js-show-cart-note').on('click', function() {
        if($(this).hasClass('open')) {
            $(this).removeClass('open')
            $('.js-collapse-note').slideUp();
        } else {
            $(this).addClass('open')
            $('.js-collapse-note').slideDown();
        }
    });

    $('.js-fly-out-checkout').on('click', function(e) {
        e.preventDefault();
        if(!$('.js-show-cart-note').hasClass('open')) {
            $('.js-collapse-note [name="note"]').remove();
        }
         $('.js-fly-out-checkout-trigger').trigger('click');
    });
}

$(document).ready(function() {
    var heroCarousel = $(".pdp__featured-mobile");
    var heroThumb = $(".pdp__nav-mobile");
    heroCarousel.slick({
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slideToScroll: 1,
        arrows: false,
        asNavFor: '.pdp__nav-mobile',

    });
    heroThumb.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor:'.pdp__featured-mobile',
        focusOnSelect: true,
        arrows: false,
    });
});

// $(document).ready(function() {
//   var getcurrrentip = localStorage.getItem("currentipaddressn");

//   if (getcurrrentip) {
//     if(getcurrrentip == 'AU' || getcurrrentip == 'NZ') {} else {
// //       $("#custom-modal").modal("show");
//     }
//   } else {
//     $.get("https://ipinfo.io/json", function (response) {
//       if (response) {
//         localStorage.setItem("currentipaddressn", response.country);
//         if(response.country == 'AU' || response.country == 'NZ') {} else {
//           $("#custom-modal").modal("show");
//         }
//       }
//     });
//   }
//   $(".select-dropdown").click(function(e) {
//     var id = $(this).attr('data-activates');
//     $('#'+id).toggleClass('active-select');
//   });

//   $('.dropdown-content.select-dropdown li').click(function(e) {
//     $(".select-dropdown").removeClass('active-select');
//   });
// });

$(document).on('click', function (event) {
  if (!$(event.target).closest('.select-dropdown').length) {
    $(".select-dropdown").removeClass('active-select');
  }
});
